import request from 'utils/request'
import authRequest from 'utils/authRequest'
import authRequested from 'utils/authRequested'
import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'
import instituteRequest from 'utils/instituteRequest'
import adminRequest from 'utils/adminRequest'
import { installSessionRefresh } from 'utils/sessionRefresh'
import { SignInSuccess } from 'modules/Auth/actions'

const initApiServices = store => {
  try {
    installSessionRefresh({
      umsRequest: request,
      instances: [
        request,
        authRequest,
        authRequested,
        corporateRequest,
        studentRequest,
        instituteRequest,
        adminRequest,
      ],
      onToken: token => store.dispatch(SignInSuccess(token)),
    })
    request.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error?.response?.statusText === 'Unauthorized') {
          localStorage.clear()
          location.reload()
          return new Promise(() => {})
        } else {
          return error?.response
        }
      }
    )
  } catch (e) {
    console.error('Error occurred while logout : in InitApiService', e)
  }
}

export default initApiServices
